import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=4dedd156&scoped=true&"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js&"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=4dedd156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedd156",
  null
  
)

export default component.exports